<template>
    <div>
        
    </div>
</template>
<script>
import {setCookie,getCookie} from '../../assets/js/cookie.js'
export default {
    data(){
        return{
            
        }
    },
    mounted(){
        this.code = this.$route.query.code;
        this.state = this.$route.query.state;
        this.getDate();
    },
    methods:{
        getDate(){
            let code = this.$route.query.code == undefined ? '' : this.$route.query.code;
            let state = this.$route.query.state == undefined ? '' : this.$route.query.state;
            //console.log('code:' + code + ',state:' + state);
            let url = '';
            if(code == ''){
                location.href = 'https://auth.1688.com/oauth/authorize?client_id=1007923&site=1688&redirect_uri=https://albbsms.2office.cn/alibaba_sms&state=albbsmslogin';
            }
            else{
                let that = this;
                if('albbsmslogin' == state){
                    let data = {'code':code}
                    this.$ajax({
                        method: 'post',
                        url: this.GLOBAL.serverSrc + '/login/albbsmslogin.json',
                        data: data,
                        headers: {
                            'Content-Type': 'application/json; charset=UTF-8'
                        }
                    }).then(function(res) {
                        if('0000000' == res.data.code)
                        {
                            that.GLOBAL.token = res.data.token
                            setCookie('2officesessionid',res.data.token,60*60*10)
                            location.href = '/main';
                        }
                        else
                        {
                            location.href = 'https://auth.1688.com/oauth/authorize?client_id=1007923&site=1688&redirect_uri=https://albbsms.2office.cn/alibaba_sms&state=albbsmslogin';
                        }
                    })
                }
                else
                {
                    location.href = 'https://auth.1688.com/oauth/authorize?client_id=1007923&site=1688&redirect_uri=https://albbsms.2office.cn/alibaba_sms&state=albbsmslogin';
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/albbsmslogin/alibaba_sms.vue